import React, { useContext } from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import MobileContext from "../../context.js";

function Index() {
  const { t } = useTranslation();
  const mobile = useContext(MobileContext);

  const [refFirst, styleFirst] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const [refSecond, styleSecond] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.5, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const [refThree, styleThree] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(-100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.5, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  const [refData, inView] = useInView({ once: true });

  const [refBrief, styleBrief] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.brief}>
      <div ref={refFirst}>
        <animated.div className={`${css.first}`} style={styleFirst}>
          <div className={css.titleicon}></div>
          <div className={css.right}>
            <div className={css.title}>{t("新利软件（集团）股份有限公司")}</div>
            <div>
              <p>{t("$singlee_bf1")}</p>
              <br />
              <p>{t("$singlee_bf2")}</p>
            </div>
            {mobile && (
              <div>
                <br />
                <p>{t("$singlee_bf9")}</p>
                <br />
                <p>{t("$singlee_bf10")}</p>
              </div>
            )}
          </div>
        </animated.div>
      </div>

      <div ref={refData}>
        <>
          {inView ? (
            <div className={css.dataBox}>
              <div className={css.dataitem}>
                <div className={css.top}>
                  <CountUp start={0} end={30}></CountUp>+
                  <div className={css.rt}>
                    <span>年</span>
                  </div>
                </div>
                <div className={css.bot}>{t("$singlee_bf3")}</div>
              </div>
              <div className={css.dataitem}>
                <div className={css.top}>
                  <CountUp start={0} end={20}></CountUp>+
                  <div className={css.rt}>
                    <span>个</span>
                  </div>
                </div>
                <div className={css.bot}>{t("$singlee_bf4")}</div>
              </div>
              <div className={css.dataitem}>
                <div className={css.top}>
                  <CountUp start={0} end={100}></CountUp>+
                  <div className={css.rt}>
                    <span>家</span>
                  </div>
                </div>
                <div className={css.bot}>{t("$singlee_bf5")}</div>
              </div>
              <div className={css.dataitem}>
                <div className={css.top}>
                  <CountUp start={0} end={20}></CountUp>w+
                  <div className={css.rt}>
                    <span>家</span>
                  </div>
                </div>
                <div className={css.bot}>{t("$singlee_bf6")}</div>
              </div>
              <div className={css.dataitem}>
                <div className={css.top}>
                  <CountUp start={0} end={120}></CountUp>w+
                  <div className={css.rt}>
                    <span>家</span>
                  </div>
                </div>
                <div className={css.bot}>{t("$singlee_bf7")}</div>
              </div>
            </div>
          ) : null}
        </>
      </div>

      <div className={css.secondBox}>
        <div ref={refSecond} className={css.second}>
          <animated.div className={css.secondInner} style={styleSecond}>
            <div className={css.bg}></div>
          </animated.div>
        </div>
        <div ref={refThree} className={css.three}>
          {!mobile && (
            <animated.div style={styleThree}>
              <div className={css.title}>{t("$singlee_bf8")}</div>
              <div>
                <p>{t("$singlee_bf9")}</p>
                <br />
                <p>{t("$singlee_bf10")}</p>
              </div>
            </animated.div>
          )}
        </div>
      </div>

      <div ref={refBrief}>
        {mobile && (
          <div className={css.briefBoxtitle}>{t("$singlee_bf11")}</div>
        )}
        <animated.div style={styleBrief} className={css.briefBox}>
          {mobile ? (
            <>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief2}`}></div>
                  <div className={css.title}>{t("$singlee_bf12")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf13")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief3}`}></div>
                  <div className={css.title}>{t("$singlee_bf14")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf15")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief4}`}></div>
                  <div className={css.title}>{t("$singlee_bf16")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf17")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief5}`}></div>
                  <div className={css.title}>{t("$singlee_bf18")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf19")}</div>
              </div>
              {/* <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief6}`}></div>
                  <div className={css.title}>{t("$singlee_bf20")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf21")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief7}`}></div>
                  <div className={css.title}>{t("$singlee_bf22")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf23")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief8}`}></div>
                  <div className={css.title}>{t("$singlee_bf24")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf25")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief9}`}></div>
                  <div className={css.title}>{t("$singlee_bf26")}</div>
                </div>
                <div className={css.content}>
                  {t("$singlee_bf27")}
                  <br />
                  {t("$singlee_bf27-1")}
                </div>
              </div>
              <div className={`${css.item}`}>
                <div className={css.contains}>
                  <div className={`${css.briefitem} ${css.brief10}`}></div>
                  <div className={css.title}>{t("$singlee_bf28")}</div>
                </div>
                <div className={css.content}>{t("$singlee_bf29")}</div>
              </div> */}
            </>
          ) : (
            <>
              <div className={`${css.itemhover}`}>
                <div className={css.brief1}></div>
                <div className={css.title}>{t("$singlee_bf11")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief2}`}></div>
                <div className={css.title}>{t("$singlee_bf12")}</div>
                <div className={css.content}>{t("$singlee_bf13")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief3}`}></div>
                <div className={css.title}>{t("$singlee_bf14")}</div>
                <div className={css.content}>{t("$singlee_bf15")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief4}`}></div>
                <div className={css.title}>{t("$singlee_bf16")}</div>
                <div className={css.content}>{t("$singlee_bf17")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief5}`}></div>
                <div className={css.title}>{t("$singlee_bf18")}</div>
                <div className={css.content}>{t("$singlee_bf19")}</div>
              </div>
              {/* <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief6}`}></div>
                <div className={css.title}>{t("$singlee_bf20")}</div>
                <div className={css.content}>{t("$singlee_bf21")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief7}`}></div>
                <div className={css.title}>{t("$singlee_bf22")}</div>
                <div className={css.content}>{t("$singlee_bf23")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief8}`}></div>
                <div className={css.title}>{t("$singlee_bf24")}</div>
                <div className={css.content}>{t("$singlee_bf25")}</div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief9}`}></div>
                <div className={css.title}>{t("$singlee_bf26")}</div>
                <div className={css.content}>
                  {t("$singlee_bf27")}
                  <br />
                  {t("$singlee_bf27-1")}
                </div>
              </div>
              <div className={`${css.item}`}>
                <div className={`${css.briefitem} ${css.brief10}`}></div>
                <div className={css.title}>{t("$singlee_bf28")}</div>
                <div className={css.content}>{t("$singlee_bf29")}</div>
              </div> */}
            </>
          )}
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
